<template>
  <modal>
    <div class="content">
      <slot></slot>
    </div>
  </modal>
</template>
s
<script lang="ts">
import {
  Component, Vue, Prop,
} from 'vue-facing-decorator';
import Modal from './Modal.vue';

@Component({
  name: 'Testimonial',
  components: { Modal },
})
export default class Testimonial extends Vue {

}
</script>

<style lang="scss" scoped>
  @import "../styles/utilities";

  .content {
    width: 95%;
    margin: 200px auto 100px;
    ::v-deep {
      > p {
        @include emphasised-text;
      }
      > q {
        @include body-text(true);
        margin: $verticalMargin--larger 0;
      }
    }
    @include small {
      width: 600px;
    }
    @include medium {
      width: 800px;
    }
  }
</style>
